import { Link } from "react-router-dom";
import { Flower, ShieldCheck } from "@phosphor-icons/react";

const YEAR = new Date().getFullYear();

export default function SiteFooter({ compact = false }) {
  return (
    <footer className="border-t border-border bg-cream" data-testid="site-footer">
      <div className={`max-w-[1400px] mx-auto px-6 lg:px-10 ${compact ? "py-10" : "py-16"}`}>
        {/* Mission */}
        <div className="grid md:grid-cols-12 gap-8 pb-10 border-b border-border">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <Flower size={22} weight="duotone" className="text-coral-700" />
              <span className="font-display text-xl">Wingwomen</span>
            </div>
            <p className="mt-4 text-sm text-ink/75 leading-relaxed max-w-md">
              Wingwomen is a peer support platform that leverages artificial intelligence to
              connect patients around their reproductive health, matching women with similar
              lived experience, and offering community, conversation, and clarity.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs tracking-[0.2em] uppercase text-muted-foreground mb-3">Platform</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-coral-700">Home</Link></li>
              <li><Link to="/auth" className="hover:text-coral-700">Sign in</Link></li>
              <li><Link to="/auth?mode=register" className="hover:text-coral-700">Join the circle</Link></li>
              <li><Link to="/contact" data-testid="footer-contact" className="hover:text-coral-700">Contact</Link></li>
              <li><Link to="/press" data-testid="footer-press" className="hover:text-coral-700">Press kit</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs tracking-[0.2em] uppercase text-muted-foreground mb-3">Policies</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/terms" data-testid="footer-terms" className="hover:text-coral-700">Terms of Service</Link></li>
              <li><Link to="/privacy" data-testid="footer-privacy" className="hover:text-coral-700">Privacy Policy</Link></li>
              <li><Link to="/terms#community" className="hover:text-coral-700">Community rules</Link></li>
            </ul>
          </div>
        </div>

        {/* Disclosures */}
        <div className="grid md:grid-cols-3 gap-6 py-10 border-b border-border text-xs leading-relaxed text-ink/70">
          <div>
            <div className="flex items-center gap-1.5 tracking-[0.2em] uppercase text-sage-700 mb-2">
              <ShieldCheck size={12} weight="duotone" /> AI Disclosure
            </div>
            <p>
              Wingwomen features that generate text (the AI Health Navigator, community
              summaries, and safety scans) are powered by <strong>Anthropic's Claude Sonnet 4.5</strong> large
              language model. AI responses may be inaccurate, incomplete, or out of date. Always
              apply your own judgment and consult a licensed clinician before acting on anything
              you read here.
            </p>
          </div>
          <div>
            <div className="tracking-[0.2em] uppercase text-sage-700 mb-2">Medical Disclaimer</div>
            <p>
              Content on Wingwomen is for informational and peer-support purposes only and is
              <strong> not medical advice, diagnosis, or treatment</strong>. Wingwomen, its operators,
              employees, and affiliates <strong>disclaim any and all liability</strong> for
              information obtained or shared on the platform. Never disregard professional medical
              advice or delay seeking it because of something you read on Wingwomen. In an
              emergency, call your local emergency number.
            </p>
          </div>
          <div>
            <div className="tracking-[0.2em] uppercase text-sage-700 mb-2">Legal Disclaimer</div>
            <p>
              Nothing on this platform constitutes a recommendation about
              <strong> how, when, whether, or from whom you should receive treatment</strong>. Any
              suggestion, story, or referral posted by another user (a "Peer") or by any
              third-party provider is that party's own view. <strong>Wingwomen is not
              responsible</strong> for any recommendation, favorable or unfavorable, made by any
              Peer or provider on or through the platform. You are solely responsible for your
              healthcare decisions.
            </p>
          </div>
        </div>

        {/* Base */}
        <div className="pt-8 flex flex-wrap items-center justify-between gap-4 text-xs text-muted-foreground">
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
            <span>A product of Wingwomen, Inc.</span>
            <span className="hidden sm:inline text-muted-foreground/40">·</span>
            <span>© 2021–{YEAR} Wingwomen, Inc. All rights reserved.</span>
          </div>
          <div className="flex flex-wrap gap-5">
            <Link to="/terms" className="hover:text-coral-700">Terms</Link>
            <Link to="/privacy" className="hover:text-coral-700">Privacy</Link>
            <Link to="/accessibility" className="hover:text-coral-700">Accessibility</Link>
            <Link to="/terms#community" className="hover:text-coral-700">Community</Link>
            <span>Not medical advice.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
